// https://github.com/axios/axios
import { Message,Loading } from 'element-ui';
import axios from 'axios'
import router from '../router'
import conf from '../config/api'
import utils from './util'
let cookie = {
    set:function(key,val,time){//设置cookie方法
        var date=new Date(); //获取当前时间
        var expiresDays=time;  //将date设置为n天以后的时间
        date.setTime(date.getTime()+expiresDays*24*3600*1000); //格式化为cookie识别的时间
        if(key == 'user_info'){
            val = escape(val)//对val进行编码兼容Safari
        }
        document.cookie=key + "=" + val +";expires="+date.toGMTString() + ';Domain=' + 'linkstars.com' + ";path=/";  //设置cookie
        // document.cookie=key + "=" + val +";expires="+date.toGMTString();  //设置cookie
    },
    get:function(key){//获取cookie方法
        /*获取cookie参数*/
        var getCookie = document.cookie.replace(/[ ]/g,"");  //获取cookie，并且将获得的cookie格式化，去掉空格字符
        var arrCookie = getCookie.split(";")  //将获得的cookie以"分号"为标识 将cookie保存到arrCookie的数组中
        var tips;  //声明变量tips
        for(var i=0;i<arrCookie.length;i++){   //使用for循环查找cookie中的tips变量
            var arr=arrCookie[i].split("=");
             //将单条cookie用"等号"为标识，将单条cookie保存为arr数组
            if(key==arr[0]){  //匹配变量名称，其中arr[0]是指的cookie名称，如果该条变量为tips则执行判断语句中的赋值操作
                tips=arr[1];  
                if(key == 'user_info'){
                    arr[1] = unescape(arr[1])//对获取的数据进行解码
                    let newarr =arr[1].split(',')//把字符串转化为对象格式
                    let obj = {}
                    for(let j=0;j<newarr.length;j++){
                        let tmp = newarr[j].split(':')
                        obj[tmp[0]] = tmp[1]
                    }
                    tips=obj;   //将cookie的值赋给变量tips
                }
                break;   //终止for循环遍历
            }
        }
        return tips;
    },
    delete:function(key){ //删除cookie方法
        let tips = '';
         var date = new Date(); //获取当前时间
         date.setTime(date.getTime()-10000); //将date设置为过去的时间
         document.cookie = key + "=v; expires =" +date.toGMTString() + ';Domain=' + 'linkstars.com' + ";path=/";//设置cookie
        //  document.cookie = key + "=v; expires =" +date.toGMTString();//设置cookie
        return tips;
    }
}

let setAuth = (auth_token, user_info) => {
    let loginTime = new Date().getTime();
    if (auth_token) {
        // window.localStorage.setItem('loginTime', loginTime);
        // window.localStorage.setItem('auth_token', auth_token);
        cookie.set('auth_token', auth_token,7);
    }
    if (user_info) {
        let str = ''
        for(let key in user_info){
            str += key+':'+ user_info[key]+','
        }
        cookie.set('user_info',str,7);
        // window.sessionStorage.setItem('user_info', JSON.stringify(user_info));
    }
}

let getAuth = (name) => {
    if (name && cookie.get(name)) {
        return cookie.get(name);
    }
    return ''
}

let removeAuth = () => {
    // window.sessionStorage.removeItem('auth_token');
    // window.sessionStorage.removeItem('user_info');
    // window.sessionStorage.removeItem('loginTime');
    cookie.delete('auth_token');
    cookie.delete('user_info');
    cookie.delete('loginTime');
}
// 鉴权不过
let goLogin = (code) => {
    removeAuth();
    return router.push({
        path: '/login',
        query: {code: code||'',redirect: router.currentRoute.fullPath}  //从哪个页面跳转
    });
}
let overtime = '';
let loading=null;
// // axios 配置
axios.defaults.timeout = 10000;
axios.defaults.baseURL = conf.api;
// axios.defaults.withCredentials=true
// axios.defaults.withCredentials = false;
// axios.defaults.responseType = 'json';

// http request 拦截器
axios.loading = null;

axios.cleanLoad = () => {
    setTimeout(axios.loading, 200);
    axios.loading = null;
}

axios.interceptors.request.use(
    request => {
        overtime = request.url;
        // console.log(request.url,'444')
        loading=Loading.service({ fullscreen: true });
        request.headers['Authorization'] = `Bearer ${cookie.get('auth_token')}`;
        // request.headers['Cookie'] = `PHPSESSID=${cookie.get('PHPSESSID')||''}`;
        // console.log(cookie.get('PHPSESSID'),'2222')
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);


// http response 拦截器
axios.interceptors.response.use(
    // setTimeout(()=>{
    //     hideLoading();
    //    },500),
    response => {
        if(loading){
            setTimeout(()=>{
                loading.close();
            },200)
        }
        if (response.data.code == 4010) {
            Message.success({
                duration:5000,
                center: true,
                type:'error',
                message:`4010 ${response.data.msg}`
            })
            removeAuth()
            return goLogin('401');
        }
        return response.data;
    },
    error => {
        if(loading){
            setTimeout(()=>{
                loading.close();
            },200)
        }
        if (error.response) {
            removeAuth();
            console.log(error.response)
            if (error.response.status == 401) {
                Message.error({
                    duration:5000,
                    center: true,
                    type:'error',
                    message:`权限不足，请联系管理员`
                })
                return goLogin('401');
            }
            Message.error({
                duration:5000,
                center: true,
                type:'error',
                message:`status:${error.response.status} meg:接口异常`
            })
        } else if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
            Message.error({
                duration:5000,
                center: true,
                type:'error',
                message:`抱歉当前请求超时了,请检测网络是否连接或者刷新后重试！`
            })
        } else {
            Message.error({
                duration:5000,
                center: true,
                type:'error',
                message:error.message
            })
        }
    
        console.log('onerror', error.message, '--', router.currentRoute.fullPath, axios.defaults.baseURL, '--', overtime, utils.dateFormat(new Date(new Date())).full)
        return Promise.reject(error)
    }
);



// 添加鉴权
axios.setAuth = setAuth;
axios.getAuth = getAuth;
axios.goLogin = goLogin;
axios.removeAuth = removeAuth;
axios.cookie = cookie;

export default axios;
